import { useState } from "react";
import moment from "moment";
import { IShipmentsPerDay } from "../../../api/ShipmentsPerDay/ShipmentsPerDay.types";
import NumberUtils from "../../../utils/number.utils";
import WidgetNivoBase from "../Widget.nivo.base";
import Tooltips from "../../common/Tooltips/Tooltips";
import Toggler from "../../common/Toggler/Toggler";
import "./styles.scss";

interface Props {
  data: IShipmentsPerDay[];
}

interface IincotermData {
  date: string,
  [key: string]: number | string
}

function ShipmentsAndContainersByIncoTerm({ data }: Props) {
  let incoTerms: string[] = [];
  const [checked, setChecked] = useState(true);

  function getData() {
    if (data) {
      if (checked) {
        const shipmentData: IincotermData[] = data.reduce((res: IincotermData[], item: IShipmentsPerDay) => {
          const { departureDate, incoterms, shipmentCount } = item;
          let date = moment(departureDate).format("MM/YYYY");
          date = date[0] === "0" ? date.slice(1) : date;
          const shipments = parseInt(shipmentCount);
          const existingItem = res.find(v => v.date === date);

          if (!incoTerms.includes(incoterms)) {
            incoTerms.push(incoterms);
          }

          if (existingItem) {
            existingItem[incoterms] = (existingItem[incoterms] as number || 0) + shipments;
          } else {
            const newItem: IincotermData = {
              date,
              [incoterms]: shipments
            }

            res.push(newItem);
          }

          return res;
        }, []);

        return shipmentData;
      } else {
        const containerData: IincotermData[] = data.reduce((res: IincotermData[], item: IShipmentsPerDay) => {
          const { departureDate, incoterms, containerCount } = item;
          let date = moment(departureDate).format("MM/YYYY");
          date = date[0] === "0" ? date.slice(1) : date;
          const containers = parseInt(containerCount);
          const existingItem = res.find(v => v.date === date);

          if (!incoTerms.includes(incoterms)) {
            incoTerms.push(incoterms);
          }

          if (existingItem) {
            existingItem[incoterms] = (existingItem[incoterms] as number || 0) + containers;
          } else {
            const newItem: IincotermData = {
              date,
              [incoterms]: containers
            }

            res.push(newItem);
          }

          return res;
        }, []);

        return containerData;
      }
    }
  }

  return (
    <div className="shipments-and-containers-by-incoterm">
      <WidgetNivoBase.Bar
        title={
          <Tooltips
            label={
              <>
                <span><b>Inco Terms</b> - First Characters of Inco terms in IE</span>
                <span><b>Actual Departure Date</b> &gt; 2021-01-01</span>
              </>
            }
            children="Shipments & Containers By IncoTerm"
          />
        }
        data={getData()}
        keys={[...incoTerms]}
        indexBy="date"
        marginBottom={70}
        axisLeftName="Totals"
        axisBottomName=""
        axisBottomRotation={-45}
        groupMode="stacked"
        colors={{ scheme: "set3" }}
        formatValue={(v) => NumberUtils.toShortened(v, 2)}
        legendLabel={(el: any) => el.id.slice(0, 3)}
        legends={[
          {
            dataFrom: "keys",
            anchor: "bottom",
            direction: "row",
            itemWidth: 35,
            itemHeight: 12,
            itemDirection: "top-to-bottom",
            itemsSpacing: 8,
            symbolShape: "circle",
            symbolSize: 12,
            toggleSerie: true,
            translateX: 0,
            translateY: 50,
          },
        ]}
        tooltip={({ id, value, color }) => (
          <div className="tooltip-panel" style={{ color }}>
            <div><strong>{id}</strong></div>
            <div>{checked ? "Shipments: " : "Containers: "}<strong>{NumberUtils.numberWithCommas(value)}</strong></div>
          </div>
        )}
        toggler={<Toggler label={checked ? "Shipments" : "Containers"} checked={checked} toggleChart={(v) => setChecked(v)} />}
      />
    </div>
  );
}

export default ShipmentsAndContainersByIncoTerm;
